import { render } from "./file_preview_component.html?vue&type=template&id=123b41ca&external"
import script from "./file_preview_component.js?vue&type=script&lang=js&external"
export * from "./file_preview_component.js?vue&type=script&lang=js&external"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__